/* SPDX-License-Identifier: AGPL-3.0-or-later */

import { Component, signal } from '@angular/core';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrl: './confirm-dialog.component.scss',
})
export class ConfirmDialogComponent {
  actionToPerform = signal<string | undefined>(undefined);
  infoNote = signal<string | undefined>(undefined);
  actionButtonText = signal<string | undefined>(undefined);
  isDeleteDialog = signal<boolean>(false);
}
